@if (message) {
  <span [class]="icon.class">
    <rma-icon [glyph]="icon.icon" />
  </span>
  @if (isHtml) {
    <span class="wrap-break-word" [innerHtml]="message"></span>
  } @else {
    <span class="wrap-break-word">{{ message }}</span>
  }
  @if (dismissible) {
    <button type="button" class="flex! items-center!" (click)="dismiss.emit()">
      <rma-icon glyph="clear" />
    </button>
  }
}
